import React from "react";
import "./index.css";
export default function Content() {
  return (
    <div className="content">
      <div className="about">
        <h1>About</h1>
        <p>
          I am a frontend developer who is trying to learn machine learning. I
          try to keep up with various fields, and am always looking for new
          things to learn.
        </p>
      </div>
      <div className="interests">
        <h1>Interests</h1>
        <p>
          Food appreciator. Bibliophile,audiophile. Human internet crawler .
          Entrepreneur. Random trivia collector. Coffee dependent life form.
        </p>
      </div>
    </div>
  );
}
